import axios from '@/utils/api'

const state = {}

const getters = {}

const actions = {
  async getOrigemsConflito ({ commit }) {
    const response = await axios({
      method: 'get',
      url: `api/v1/origensConflito`
    })
    return response
  },
  async arquivarConflito ({ commit }, id) {
    const response = await axios({
      method: 'put',
      url: `api/v1/conflitos/arquivar/${id}`
    })
    return response
  },
  async enviarArquivarConflito ({ commit }, id) {
    const response = await axios({
      method: 'put',
      url: `api/v1/conflitos/enviarArquivar/${id}`
    })
    return response
  },
  async finalizarConflito ({ commit }, id) {
    const response = await axios({
      method: 'put',
      url: `api/v1/conflitos/finalizar/${id}`
    })
    return response
  },
  async getStatusConflito ({ commit }) {
    const response = await axios({
      method: 'get',
      url: `api/v1/origensConflito/status`
    })
    return response
  },
  async getJurisdicaoConflito ({ commit }) {
    const response = await axios({
      method: 'get',
      url: `api/v1/origensConflito/jurisdicao`
    })
    return response
  },
  async getConflitosByFiltro ({ commit }, filtro) {
    const response = await axios({
      method: 'post',
      url: `api/v1/conflitos/filtro`,
      data: filtro
    })
    return response
  },
  async saveConflito ({ commit }, conflito) {
    const response = await axios({
      method: 'post',
      url: `api/v1/conflitos`,
      loaderText: 'Processando dados da geometria...',
      data: conflito
    })
    return response
  },
  async getConflitoById ({ commit }, id) {
    const response = await axios({
      method: 'get',
      url: `api/v1/conflitos/${id}`
    })
    return response
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/conflito.js